module.exports = __webpack_public_path__ + "img/pantalla-8-mobile.bdaa51fb.png";